import { Http } from '@/lib/http';
export class YapuService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/yapu-management/';
  }

  getClimateRiskRatings() {
    return this.httpClient().get(`${this.endpoint}climate-risk-ratings/`);
  }
  getGlobalClimateRiskRatings() {
    return this.httpClient().get(
      `${this.endpoint}global-climate-risk-ratings/`
    );
  }
  getYAPUManagementSettings() {
    return this.httpClient().get(`${this.endpoint}yapu-settings/`);
  }

  updateClimateRiskRating(obj) {
    return this.httpClient().patch(
      `${this.endpoint}climate-risk-ratings/${obj.id}/${obj.type}`,
      obj.body
    );
  }
  updateGlobalClimateRiskRating(obj) {
    return this.httpClient().patch(
      `${this.endpoint}global-climate-risk-ratings/${obj.id}`,
      obj.body
    );
  }
  updateYAPUManagementSettings(obj) {
    return this.httpClient().patch(
      `${this.endpoint}yapu-settings/${obj.id}`,
      obj.body
    );
  }
}
